import Modal from "bootstrap/js/dist/modal";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { customModalCancelButton, themeBasedVerifyOtpModal } from "./customStyles";
import { useTheme } from "next-themes";
// import { useAuth } from "../store/AuthContext";

const DynamicOtpModal = forwardRef(({ title, otpType, otpValue, onChangeOtp, onConfirm, onClose, loading }, ref) => {
  const modalRef = useRef();

  const { theme } = useTheme();

  useImperativeHandle(ref, () => ({
    show: () => Modal.getOrCreateInstance(modalRef.current).show(),
    hide: () => Modal.getOrCreateInstance(modalRef.current).hide(),
    toggle: () => Modal.getOrCreateInstance(modalRef.current).toggle(),
  }));

  // const handleConfirm = async (e) => {
  // 	e.preventDefault();
  // 	try {
  // 		await onConfirm(otpType);
  // 	} finally {
  // 		onClose();
  // 	}
  // }

  return (
    <div className='modal fade' id='fundModal' tabIndex='-1' aria-labelledby='fundModal' aria-hidden='true' ref={modalRef}>
      <div
        className='modal-dialog modal-dialog-centered m-2 mx-md-auto'
        style={{
          ["--bs-modal-width"]: "400px",
        }}
      >
        <form
          className='modal-content'
          style={{
            backgroundColor: theme === "light" ? "rgb(179, 179, 179)" : "rgb(50, 50, 50)",
            border: "none",
          }}
        >
          <div
            className='modal-header align-items-center justify-content-between border-0'
            style={{
              // backgroundColor: theme === 'light' ? 'rgb(101, 138, 181)' : 'rgb(49, 101, 162)',
              padding: "1rem 1rem .3rem 1rem",
            }}
          >
            <div style={{ height: "32px", width: "32px", marginLeft: ".15rem" }}></div>

            <h1 className='modal-title fs-4 ' id='goalModal' style={{ color: theme === "light" ? "rgb(51, 116, 196)" : "rgb(224, 232, 240)" }}>
              {title}
            </h1>
            <button
              type='button'
              className='btn-close p-0 d-flex align-items-center justify-content-center'
              aria-label='Close'
              style={{
                marginLeft: "0",
                marginRight: ".15rem",
                color: theme === "light" ? "rgb(77, 77, 77)" : "rgb(255,255,255)",
                background: "none",
                height: "32px",
                width: "32px",
                ["--bs-btn-close-opacity"]: "0.65",
                ["--bs-btn-close-hover-opacity"]: "0.85",
              }}
              onClick={onClose}
            >
              <svg xmlns='http://www.w3.org/2000/svg' height={18} width={18} stroke='currentColor' fill='currentColor' viewBox='0 0 16 16'>
                <path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'></path>
              </svg>
            </button>
          </div>

          {/* <hr className="m-0" /> */}

          <div className='modal-body p-0'>
            <div className='row w-100 mx-auto flex-column gap-3 flex-nowrap p-2 pb-2'>
              <div className='col-12 p-0'>
                <hr className='my-2 mx-1' style={{ color: theme === "light" ? "rgb(77, 77, 77)" : "rgb(134, 151, 168)" }} />
              </div>
              <div className='col p-0 px-2'>
                <div
                  className='d-flex flex-column align-items-center justify-content-center flex-nowrap mx-auto my-4'
                  style={{
                    // minHeight: '180px',
                    maxWidth: "240px",
                  }}
                >
                  <div className='w-100 mx-auto'>
                    <div
                      className='text-center'
                      style={{
                        fontSize: "1.4rem",
                        color: theme === "light" ? "rgb(33,37,41)" : "rgb(202, 202, 202)",
                        fontWeight: "400",
                        letterSpacing: ".06em",
                        lineHeight: "1",
                      }}
                    >
                      OTP
                    </div>
                    {/* <input type="text" className={`form-control goal-form-control${theme === 'dark' ? '-dark' : ''} rounded-pill text-center`} name="total_amount" value={otpValue} placeholder='Enter OTP' style={{ */}
                    <input
                      type='text'
                      className={`form-control verify-form-control rounded-pill text-center`}
                      name='total_amount'
                      value={otpValue}
                      placeholder='Enter OTP'
                      style={{
                        ...themeBasedVerifyOtpModal(theme),
                        marginTop: ".6rem",
                        fontSize: "1.4rem",
                      }}
                      onChange={onChangeOtp}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='modal-footer border-0 justify-content-between'>
            <button
              type='button'
              className='btn border-0 px-4 pb-2'
              onClick={onClose}
              style={{
                ...customModalCancelButton,
                minWidth: "80px",
              }}
            >
              Cancel
            </button>
            <button
              type='button'
              className='btn btn-primary border-0 px-2 pb-2 text-center'
              disabled={loading}
              onClick={() => onConfirm(otpType)}
              style={{
                width: "85px",
              }}
            >
              {loading ? (
                <span
                  className='spinner-border spinner-border-sm'
                  aria-hidden='true'
                  style={{
                    fontSize: "0.85rem",
                    height: "15px",
                    width: "15px",
                  }}
                ></span>
              ) : (
                "Confirm"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

DynamicOtpModal.displayName = "DynamicOtpModal";

export default DynamicOtpModal;
